import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, HashRouter, Route, Switch } from "react-router-dom";
import HomeV1 from './components/home-v1';
import About from './components/about';
import NcvtCourse from './components/ncvt-course';
import IndustrialSchool from './components/industrial-school-courses';
import Gallery from './components/gallery';
import Contact from './components/contact';
import UniversityOfMadras from './components/university-of-madras';
import BharathidasanUniversity from './components/bharathidasan-university';
import TamilNaduOpenUniversity from './components/tamilnadu-open-university';
import SchoolCourses from './components/school-courses';
import TMG from './components/tmg-college-of-arts-and-science';
import NEET from './components/neet-courses-in-chennai';
import JEE from './components/jee-courses-in-chennai';
import NATA from './components/nata-courses-in-chennai';
import NRA from './components/nra-cet-courses-in-chennai';
import DATAAI from './components/data-science-and-artificial-intelligence-courses';
import HotelManagement from './components/hotel-management-courses-in-chennai';
import OnlinePayment from './components/online-payment';
import GATE from './components/gate-coaching-centre-in-chennai';
import NET from './components/ugc-net-coaching-centre-in-chennai';
import SLET from './components/slet-coaching-centre-in-chennai';
import IES from './components/ies-training-institute-chennai';
import Engineering from './components/engineering-and-architecture-guidance-program';
import Rule from './components/rules-and-regulations.js';
import Administration from './components/administration';
import TNPSC from './components/tnpsc-coaching-centre-in-chennai';
import Appointment from './components/global-components/appointment';
import ThankYou from './components/section-components/thank-you';
import distanceEducation from './components/distance-education';
import InformationTechnologyCourses from './components/information-technology-courses';
import RepeaterBatch from './components/repeater-batch-in-chennai';
import ClearNeetBlog from './components/blog-components/Clear-Neet-Blog';
import NE from './components/blog-components/NEET';

// industrial-school-courses.js 


class Root extends Component {
    render() {
        return(
                // <HashRouter basename="/">
	              //   <div>
	              //   <Switch>
                //         <Route exact path="/" component={HomeV1} />
                //         <Route path="/course" component={Course} />
                //         <Route path="/course-details" component={CourseDetails} />
                //         <Route path="/about" component={About} />
                //         <Route path="/event" component={Event} />
                //         <Route path="/ncvt-course" component={NcvtCourse} />
                //         <Route path="/university-of-madras" component={UniversityOfMadras} />
                //         <Route path="/bharathidasan-university" component={BharathidasanUniversity} />
                //         <Route path="/industrial-school-courses" component={IndustrialSchool} />
                //         <Route path="/tamilnadu-open-university" component={TamilNaduOpenUniversity} />
                //         <Route path="/tmg-college-of-arts-and-science" component={TMG} />
                //         <Route path="/school-courses" component={SchoolCourses} />
                //         <Route path="/neet-courses-in-chennai" component={NEET} />
                //         <Route path="/nata-courses-in-chennai" component={NATA} />
                //         <Route path="/jee-courses-in-chennai" component={JEE} />
                //         <Route path="/nra-cet-courses-in-chennai" component={NRA} />
                //         <Route path="/hotel-management-courses-in-chennai" component={HotelManagement} />
                //         <Route path="/data-science-and-artificial-intelligence-courses" component={DATAAI} />
                //         <Route path="/online-payment" component={OnlinePayment} />
                //         <Route path="/instructor" component={Instructor} />
                //         <Route path="/instructor-details" component={InstructorDetails} />
                //         <Route path="/pricing" component={Pricing} />
                //         <Route path="/gallery" component={Gallery} />
                //         <Route path="/sign-in" component={SignIn} />
                //         <Route path="/sign-up" component={SignUp} />
                //         <Route path="/contact" component={Contact} />
                //         <Route path="/blog" component={Blog} />
                //         <Route path="/blog-details" component={BlogDetails} />
	              //   </Switch>
	              //   </div>
                // </HashRouter>
                <Router>
                  <Switch>
                    <Route exact path="/" component={HomeV1} />
                    <Route path="/about" component={About} />
                    <Route path="/ncvt-course" component={NcvtCourse} />
                    <Route path="/university-of-madras" component={UniversityOfMadras} />
                    <Route path="/bharathidasan-university" component={BharathidasanUniversity} />
                    <Route path="/industrial-school-courses" component={IndustrialSchool} />
                    <Route path="/tamilnadu-open-university" component={TamilNaduOpenUniversity} />
                    <Route path="/tmg-college-of-arts-and-science" component={TMG} />
                    <Route path="/school-courses" component={SchoolCourses} />
                    <Route path="/neet-courses-in-chennai" component={NEET} />
                    <Route path="/nata-courses-in-chennai" component={NATA} />
                    <Route path="/jee-courses-in-chennai" component={JEE} />
                    <Route path="/nra-cet-courses-in-chennai" component={NRA} />
                    <Route path="/online-payment" component={OnlinePayment} />
                    <Route path="/hotel-management-courses-in-chennai" component={HotelManagement} />
                    <Route path="/data-science-and-artificial-intelligence-courses" component={DATAAI} />
                    <Route path="/gate-coaching-centre-in-chennai" component={GATE} />
                    <Route path="/ugc-net-coaching-centre-in-chennai" component={NET} />
                    <Route path="/slet-coaching-centre-in-chennai" component={SLET} />
                    <Route path="/ies-training-institute-chennai" component={IES} />
                    <Route path="/engineering-and-architecture-guidance-program" component={Engineering} />
                    <Route path="/rules-and-regulations" component={Rule} />
                    <Route path="/tnpsc-coaching-centre-in-chennai" component={TNPSC} />
                    <Route path="/administration" component={Administration} />
                    <Route path="/contact" component={Contact} />
                    <Route path="/gallery" component={Gallery} />
                    <Route path="/appointment" component={Appointment} />
                    <Route path="/thank-you" component={ThankYou} />
                    <Route path="/distance-education" component={distanceEducation} />
                    <Route path="/information-technology-courses" component={InformationTechnologyCourses} />
                    <Route path="/repeater-batch-in-chennai" component={RepeaterBatch}/>
                    <Route path="/clear-neet-first-attempt-roadmap-2025" component={ClearNeetBlog}/>
                     <Route path="/crack-neet-2025" component={NE}/>
                  </Switch>
              </Router>
        )
    }
}

export default Root;

ReactDOM.render(<Root />, document.getElementById('miet'));
{/* <Router>
           
           <Switch>
           <Route exact path="/" component={HomeV1} />
             <Route path="/about" component={About} />
           </Switch>
         
       </Router> */}